import { Component, OnInit, Input } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { SafeMove } from "@app/core/models/safeMove";

@Component({
  selector: "sa-stats",
  templateUrl: "./stats.component.html",
})
export class StatsComponent implements OnInit {
  @Input("total1") total1: number;
  @Input("total2") total2: number;
  @Input("total3") total3: number;
  constructor() {}

  private token = localStorage.getItem("token");

  ngOnInit() {}
}
